export const featuredMovies = [
  {
    id: 1,
    title: '流浪地球3',
    category: '科幻',
    year: 2026,
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20astronauts%20and%20spaceship%20in%20deep%20space%2C%20dramatic%20lighting%2C%20epic%20cinematic%20composition%2C%20dark%20atmosphere%20with%20orange%20and%20blue%20accents%2C%20high%20quality%20film%20poster%20style&width=800&height=450&seq=movie-featured-01&orientation=landscape',
    description: '太阳急速老化，持续膨胀，即将吞没整个太阳系。人类面临前所未有的生存危机，联合政府决定启动"流浪地球计划"。',
    tags: ['热门', '推荐', '新番'],
    updateInfo: '更新至HD',
  },
  {
    id: 2,
    title: '封神第二部',
    category: '奇幻',
    year: 2026,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythology%20fantasy%20film%20scene%20with%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20atmosphere%2C%20dark%20dramatic%20sky%2C%20golden%20and%20red%20color%20palette%2C%20cinematic%20film%20poster&width=800&height=450&seq=movie-featured-02&orientation=landscape',
    description: '殷商大军压境，姜子牙率众神迎战。封神大战一触即发，天地为之变色。',
    tags: ['热播', '推荐'],
    updateInfo: 'HD高清',
  },
  {
    id: 3,
    title: '哪吒之魔童闹海',
    category: '动画',
    year: 2026,
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20with%20a%20mythological%20young%20warrior%20in%20red%2C%20dramatic%20ocean%20waves%20and%20lightning%2C%20epic%20cinematic%20lighting%2C%20dark%20stormy%20atmosphere%2C%20animation%20movie%20poster%20style&width=800&height=450&seq=movie-featured-03&orientation=landscape',
    description: '天劫之后，哪吒和敖丙的灵魂虽保住，但肉身面临魂飞魄散的危机。太乙真人打算用七色宝莲给二人重塑肉身。',
    tags: ['热播', '高分', '推荐'],
    updateInfo: 'TC抢先版',
  },
  {
    id: 4,
    title: '庆余年第二季',
    category: '电视剧',
    year: 2026,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20scene%20with%20imperial%20palace%20setting%2C%20elegant%20costumes%2C%20warm%20golden%20lighting%2C%20dramatic%20composition%2C%20cinematic%20film%20poster%20style&width=800&height=450&seq=movie-featured-04&orientation=landscape',
    description: '范闲在经历了一系列生死考验后，再次踏入京都，一场更大的阴谋正等待着他。',
    tags: ['热播', '推荐'],
    updateInfo: '更新至36集',
  },
  {
    id: 5,
    title: '速度与激情11',
    category: '动作',
    year: 2026,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=High%20speed%20car%20chase%20action%20movie%20scene%20in%20city%20at%20night%2C%20sports%20cars%20racing%2C%20neon%20lights%2C%20intense%20dramatic%20atmosphere%2C%20cinematic%20film%20poster%20style%20with%20orange%20and%20dark%20tones&width=800&height=450&seq=movie-featured-05&orientation=landscape',
    description: '多米尼克再次面对来自过去的威胁，这一次他必须集结整个家族，完成最后一场终极任务。',
    tags: ['新番', '热门'],
    updateInfo: 'HD高清',
  },
];

export const categories = [
  { id: 'movie', name: '电影', icon: 'ri-film-line', count: 12860 },
  { id: 'tv', name: '电视剧', icon: 'ri-tv-line', count: 8920 },
  { id: 'variety', name: '综艺', icon: 'ri-live-line', count: 4560 },
  { id: 'anime', name: '动漫', icon: 'ri-emotion-line', count: 7230 },
  { id: 'documentary', name: '纪录片', icon: 'ri-vidicon-line', count: 2180 },
  { id: 'kids', name: '少儿', icon: 'ri-heart-line', count: 1540 },
];

export interface MovieItem {
  id: number;
  title: string;
  category: string;
  year: number;
  rating: number;
  image: string;
  tags: string[];
  updateInfo: string;
}

export const hotMovies: MovieItem[] = [
  {
    id: 6,
    title: '满江红2',
    category: '悬疑',
    year: 2026,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20film%20poster%20with%20ancient%20Chinese%20setting%2C%20dark%20palace%20corridors%2C%20dramatic%20lighting%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20portrait%20orientation&width=400&height=560&seq=movie-card-01&orientation=portrait',
    tags: ['热播', '高分'],
    updateInfo: 'HD高清',
  },
  {
    id: 7,
    title: '长安三万里2',
    category: '动画',
    year: 2026,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20film%20poster%20with%20Tang%20dynasty%20poets%2C%20beautiful%20landscape%20and%20calligraphy%2C%20warm%20golden%20light%2C%20artistic%20portrait%20orientation&width=400&height=560&seq=movie-card-02&orientation=portrait',
    tags: ['高分', '推荐'],
    updateInfo: 'HD高清',
  },
  {
    id: 8,
    title: '毒液3',
    category: '科幻',
    year: 2026,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Dark%20superhero%20movie%20poster%20with%20symbiote%20creature%2C%20dark%20urban%20cityscape%20background%2C%20dramatic%20moody%20lighting%2C%20black%20and%20red%20tones%2C%20portrait%20orientation&width=400&height=560&seq=movie-card-03&orientation=portrait',
    tags: ['新番'],
    updateInfo: 'TC抢先版',
  },
  {
    id: 9,
    title: '白夜追凶2',
    category: '电视剧',
    year: 2026,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20TV%20drama%20poster%20with%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20blue%20and%20dark%20tones%2C%20mysterious%20mood%2C%20portrait%20orientation&width=400&height=560&seq=movie-card-04&orientation=portrait',
    tags: ['热播', '高分', '推荐'],
    updateInfo: '更新至24集',
  },
  {
    id: 10,
    title: '孤注一掷2',
    category: '犯罪',
    year: 2026,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20film%20poster%20with%20intense%20dramatic%20scene%2C%20dark%20urban%20backdrop%2C%20red%20and%20black%20color%20scheme%2C%20suspenseful%20atmosphere%2C%20portrait%20orientation&width=400&height=560&seq=movie-card-05&orientation=portrait',
    tags: ['热播'],
    updateInfo: 'HD高清',
  },
  {
    id: 11,
    title: '三体电视剧',
    category: '电视剧',
    year: 2026,
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20cosmic%20and%20alien%20themes%2C%20deep%20space%20and%20stars%2C%20mysterious%20dark%20atmosphere%2C%20blue%20and%20purple%20cosmic%20tones%2C%20portrait%20orientation&width=400&height=560&seq=movie-card-06&orientation=portrait',
    tags: ['高分', '推荐'],
    updateInfo: '更新至30集',
  },
  {
    id: 12,
    title: '海贼王',
    category: '动漫',
    year: 2026,
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20pirate%20adventure%20poster%20with%20young%20heroes%20on%20a%20ship%2C%20ocean%20waves%2C%20colorful%20vibrant%20style%2C%20anime%20art%20style%2C%20portrait%20orientation&width=400&height=560&seq=movie-card-07&orientation=portrait',
    tags: ['热播', '高分'],
    updateInfo: '更新至1120集',
  },
  {
    id: 13,
    title: '奔跑吧兄弟',
    category: '综艺',
    year: 2026,
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20in%20colorful%20outdoor%20setting%2C%20fun%20energetic%20vibe%2C%20bright%20vibrant%20colors%2C%20entertainment%20show%20style%2C%20portrait%20orientation&width=400&height=560&seq=movie-card-08&orientation=portrait',
    tags: ['热播'],
    updateInfo: '更新至20260810期',
  },
];

export const latestMovies: MovieItem[] = [
  {
    id: 14,
    title: '志愿军：存亡之战',
    category: '战争',
    year: 2026,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20war%20film%20poster%20with%20soldiers%20in%20epic%20battle%20scene%2C%20dramatic%20smoke%20and%20fire%2C%20historical%20military%20uniforms%2C%20dark%20intense%20atmosphere%2C%20portrait%20orientation&width=400&height=560&seq=movie-new-01&orientation=portrait',
    tags: ['新番', '推荐'],
    updateInfo: 'HD高清',
  },
  {
    id: 15,
    title: '熊出没·逆转时空',
    category: '动画',
    year: 2026,
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20film%20poster%20with%20cute%20bear%20characters%20in%20forest%20setting%2C%20colorful%20and%20bright%20style%2C%20animated%20movie%20poster%2C%20portrait%20orientation&width=400&height=560&seq=movie-new-02&orientation=portrait',
    tags: ['新番'],
    updateInfo: 'HD高清',
  },
  {
    id: 16,
    title: '异人之下2',
    category: '奇幻',
    year: 2026,
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20action%20film%20poster%20with%20supernatural%20warriors%20using%20special%20powers%2C%20modern%20urban%20setting%20with%20mystical%20elements%2C%20dark%20dramatic%20style%2C%20portrait%20orientation&width=400&height=560&seq=movie-new-03&orientation=portrait',
    tags: ['新番', '热门'],
    updateInfo: 'HD高清',
  },
  {
    id: 17,
    title: '大奉打更人',
    category: '电视剧',
    year: 2026,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20poster%20with%20ancient%20detective%20in%20traditional%20Chinese%20setting%2C%20mysterious%20atmosphere%2C%20warm%20lantern%20light%2C%20portrait%20orientation&width=400&height=560&seq=movie-new-04&orientation=portrait',
    tags: ['新番', '推荐'],
    updateInfo: '更新至16集',
  },
  {
    id: 18,
    title: '碟中谍8',
    category: '动作',
    year: 2026,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20spy%20movie%20poster%20with%20agent%20running%20in%20city%2C%20intense%20chase%20scene%2C%20dramatic%20urban%20lighting%2C%20cinematic%20thriller%20style%2C%20portrait%20orientation&width=400&height=560&seq=movie-new-05&orientation=portrait',
    tags: ['新番'],
    updateInfo: 'HD高清',
  },
  {
    id: 19,
    title: '神隐',
    category: '电视剧',
    year: 2026,
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20drama%20poster%20with%20immortal%20beings%20in%20heavenly%20palace%2C%20ethereal%20white%20and%20gold%20aesthetic%2C%20dreamy%20atmosphere%2C%20portrait%20orientation&width=400&height=560&seq=movie-new-06&orientation=portrait',
    tags: ['新番'],
    updateInfo: '更新至28集',
  },
  {
    id: 20,
    title: '死侍与金刚狼',
    category: '动作',
    year: 2026,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Marvel%20superhero%20action%20comedy%20movie%20poster%20with%20two%20heroes%20in%20red%20and%20yellow%20costumes%2C%20urban%20city%20background%2C%20dynamic%20action%20pose%2C%20portrait%20orientation&width=400&height=560&seq=movie-new-07&orientation=portrait',
    tags: ['新番', '热门'],
    updateInfo: 'HD高清',
  },
  {
    id: 21,
    title: '唐诡2',
    category: '电视剧',
    year: 2026,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20TV%20drama%20poster%20with%20Tang%20dynasty%20detectives%2C%20ancient%20Chinese%20architecture%2C%20dark%20mysterious%20atmosphere%2C%20red%20lanterns%2C%20portrait%20orientation&width=400&height=560&seq=movie-new-08&orientation=portrait',
    tags: ['热播', '高分'],
    updateInfo: '更新至40集',
  },
];

export const allMoviesByCategory: Record<string, MovieItem[]> = {
  movie: hotMovies.filter(m => m.category === '悬疑' || m.category === '科幻' || m.category === '犯罪').concat(latestMovies.filter(m => m.category === '战争' || m.category === '动作')),
  tv: hotMovies.filter(m => m.category === '电视剧').concat(latestMovies.filter(m => m.category === '电视剧')),
  variety: hotMovies.filter(m => m.category === '综艺'),
  anime: hotMovies.filter(m => m.category === '动画' || m.category === '动漫').concat(latestMovies.filter(m => m.category === '动画')),
  documentary: [],
  kids: [],
};

export const articleContent: Record<number, { synopsis: string; director: string; cast: string; episodes: string; region: string; language: string; releaseDate: string }> = {
  1: { synopsis: '太阳急速老化，持续膨胀，即将吞没整个太阳系。人类面临前所未有的生存危机，联合政府决定启动"流浪地球计划"，在地球表面建造上万座行星发动机，推动地球逃离太阳系，前往4.2光年外的半人马座比邻星。这是一场持续2500年、跨越100代人的宏伟征程。然而，在穿越木星轨道的关键时刻，地球遭遇了致命危机……', director: '郭帆', cast: '吴京、刘德华、李雪健、沙溢', episodes: '1集全', region: '中国大陆', language: '汉语普通话', releaseDate: '2026-02-10' },
  2: { synopsis: '殷商太师闻仲率大军西征，姜子牙率阐教众仙下山迎战。西岐保卫战爆发，杨戬、哪吒、雷震子等英雄各显神通。闻仲布下十绝阵，姜子牙请来三山五岳高人破阵。一场关乎天下苍生命运的封神大战震撼上演。', director: '乌尔善', cast: '黄渤、费翔、于适、陈牧驰', episodes: '1集全', region: '中国大陆', language: '汉语普通话', releaseDate: '2026-07-20' },
  3: { synopsis: '天劫之后，哪吒和敖丙的灵魂虽保住，但肉身面临魂飞魄散的危机。太乙真人打算用七色宝莲给二人重塑肉身，但过程困难重重。与此同时，四海龙王联手要为敖丙讨回公道，一场更大的危机正在酝酿……', director: '饺子', cast: '吕艳婷、瀚墨、陈浩、绿绮', episodes: '1集全', region: '中国大陆', language: '汉语普通话', releaseDate: '2026-01-29' },
};

export const siteInfo = {
  name: '四虎影院',
  slogan: '海量高清影视资源免费在线观看',
  description: '四虎影院提供海量高清影视资源，涵盖电影、电视剧、综艺、动漫等多种类型，无需注册即可免费在线观看。每日更新最新影视内容，支持多线路流畅播放，是您追剧观影的首选平台。',
  keywords: ['四虎影院', '在线观看', '高清电影', '最新资源', '免费追剧', '电视剧', '官网入口'],
  stats: { movies: '12860+', tvShows: '8920+', variety: '4560+', anime: '7230+' },
  features: [
    { icon: 'ri-hd-line', title: '高清画质', desc: '支持1080P/4K超清画质，极致观影体验' },
    { icon: 'ri-speed-up-line', title: '多线路播放', desc: '多条播放线路自动切换，流畅不卡顿' },
    { icon: 'ri-refresh-line', title: '每日更新', desc: '每日更新最新影视资源，追剧不等待' },
    { icon: 'ri-user-line', title: '无需注册', desc: '无需注册登录，打开即看，方便快捷' },
  ],
};